<!-- @format -->

@if (responsibilityInfos?.length > 0) {
  <div class="row">
    <div class="col-12">
      <sis-module-responsibility-info [responsibilityInfos]="responsibilityInfos" [language]="language"> </sis-module-responsibility-info>
    </div>
  </div>
}
@if (organisations.length > 0 || hasCoordinatingOrganisations) {
  <div class="row">
    @if (organisations.length > 0) {
      <div class="col-12 col-md-6">
        <div class="form-group-mimic">
          <sis-organisation-role-share [organisations]="organisations" [organisationRoleUrn]="RESPONSIBLE_ORGANISATION_ROLE_URN">
          </sis-organisation-role-share>
        </div>
        @if (hasCoordinatingOrganisations) {
          <div class="form-group-mimic">
            <sis-organisation-role-share [organisations]="organisations" [organisationRoleUrn]="COORDINATING_ORGANISATION_ROLE_URN">
            </sis-organisation-role-share>
          </div>
        }
      </div>
    }
  </div>
}
@if (responsibilityInfos?.length === 0 && organisations.length === 0 && !hasCoordinatingOrganisations) {
  <div>
    <span>{{ "SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.NO_INFORMATION_GIVEN" | translate }}</span>
  </div>
}
